import apolloProvider from '@/graphql/apollo'

export const IMG_URL = 'https://img-sns.ugirls.tv/web/pc/'; // 网站静态图片资源基础地址
export const NEW_UGIRL_URL = 'https://app.88tang.com/new_ug/index.html';  // 新尤果下载地址
// export const OLD_UGIRL_URL = 'https://app.youguoquan.com/?channel=254#rd';
export const OLD_UGIRL_URL = 'http://app.ugirl.com/';




export const fetchData = function (param) { // graphql获取后台数据公共方法
  return apolloProvider.defaultClient.query(param);
};



// WEBPACK FOOTER //
// ./src/service/index.js